import loadable from '@loadable/component'

export const Infogram = loadable(() => import('./Infogram'))
export type { InfogramProps, InfogramRenderImageProps } from './Infogram'
